'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 271 279",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M13.208 39.856c-4.738 0-11.616-.65-13.04-1.4.134.008.27.01.405.01 1.285 0 2.555-.263 3.45-.776l21.634-11.982-.145-.42.039-.496 2.493-1.43.018-.01c4.168 1.676 9.058 2.515 13.946 2.515 6.22 0 12.436-1.36 17.171-4.075 3.585-2.056 5.812-4.602 6.684-7.266l.01-.031c1-2.877.243-8.244.243-8.244s-.35.928-.761 1.86c-.42-.847-.98-1.675-1.683-2.475-.482-1.974-1.786-3.895-3.91-5.58 5.193.672 9.869 1.931 13.017 3.736 9.474 5.434 9.216 13.857 0 19.713-6.684 4.249-14.614 5.364-21.099 5.364-7.166-.002-12.568-1.364-12.568-1.364L17.623 39.403c-.557.318-2.266.453-4.415.453m24.433-19.01c-.041-.015-.08-.033-.129-.036-1.03-.084-2.02-.156-2.99-.256-.754-.413-1.606-.646-2.47-.754-.01-.003-.021-.003-.031-.003-.036 0-.067.008-.101.013-1.241-.625-2.477-.997-3.925-1.38a.494.494 0 0 0-.612.359.59.59 0 0 0-.317.308c-1.35-.925-2.4-1.946-3.146-3.023a8.517 8.517 0 0 1-.477-2.012c.859.784 1.886 1.528 3.076 2.21 4.276 2.454 9.876 3.68 15.478 3.68 5.603 0 11.206-1.229 15.48-3.68 1.566-.9 2.846-1.9 3.84-2.967-.313 1.457-1.123 2.885-2.43 4.19-.069-.21-.268-.395-.51-.395a.532.532 0 0 0-.232.056c-3.397 1.639-6.542 2.826-10.318 3.208a.395.395 0 0 0-.292-.126c-.018 0-.036 0-.056.003a8.097 8.097 0 0 1-.914.046c-.286 0-.58-.01-.875-.02-.291-.008-.585-.018-.877-.018-.511 0-1.01.028-1.468.138-.33.077-.65.139-.97.195-1.433 0-2.868-.026-4.292-.026a.48.48 0 0 0-.442.29",
    id: "empty-reaprofile_svg__b"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.062 24.952c-5.586 0-11.17-1.207-15.434-3.624-1.186-.671-2.21-1.404-3.067-2.176-.267-.243-.52-.49-.756-.74C.597 16.073-.188 13.417.45 10.85a8.14 8.14 0 0 1 .767-1.94c-.656 1.198-.983 2.443-.98 3.685.002 2.369 1.201 4.737 3.592 6.79 3.502-10.5 13.56-18.088 25.43-18.088.694 0 1.379.035 2.06.086C28.395.606 25.228.22 22.06.22c-5.354 0-10.71 1.108-14.898 3.328-.06.033-.121.063-.18.096-.119.066-.237.129-.353.197l-.038.02a.283.283 0 0 1 .038-.02C10.89 1.424 16.476.217 22.062.217c5.586 0 11.17 1.207 15.433 3.624.844.477 1.603.985 2.28 1.518 2.118 1.659 3.417 3.55 3.898 5.495.636 2.563-.146 5.214-2.349 7.553-.99 1.05-2.267 2.035-3.829 2.921-4.26 2.414-9.847 3.624-15.433 3.624M1.217 8.909l.07-.121-.07.121m.07-.126c.007-.008.012-.018.018-.028-.006.01-.01.02-.018.028m.02-.03.016-.03-.016.03m.016-.03.015-.029-.015.028m.038-.063.016-.028-.016.028m.018-.033.016-.028-.016.028m.036-.06.016-.026-.016.026m4.917-4.553c.01-.008.021-.013.031-.02-.01.007-.02.012-.03.02m.043-.028c.01-.005.02-.013.031-.018l-.03.018m.043-.025.03-.018-.03.018m.126-.074c.013-.007.026-.012.036-.02l-.036.02",
    id: "empty-reaprofile_svg__d"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.062 24.952c-5.586 0-11.17-1.207-15.434-3.624-1.186-.671-2.21-1.404-3.067-2.176-.267-.243-.52-.49-.756-.74C.597 16.073-.188 13.417.45 10.85a8.14 8.14 0 0 1 .767-1.94c-.656 1.198-.983 2.443-.98 3.685.002 2.369 1.201 4.737 3.592 6.79 3.502-10.5 13.56-18.088 25.43-18.088.694 0 1.379.035 2.06.086C28.395.606 25.228.22 22.06.22c-5.354 0-10.71 1.108-14.898 3.328-.06.033-.121.063-.18.096-.119.066-.237.129-.353.197l-.038.02a.283.283 0 0 1 .038-.02C10.89 1.424 16.476.217 22.062.217c5.586 0 11.17 1.207 15.433 3.624.844.477 1.603.985 2.28 1.518 2.118 1.659 3.417 3.55 3.898 5.495.636 2.563-.146 5.214-2.349 7.553-.99 1.05-2.267 2.035-3.829 2.921-4.26 2.414-9.847 3.624-15.433 3.624M1.217 8.909l.07-.121-.07.121m.07-.126c.007-.008.012-.018.018-.028-.006.01-.01.02-.018.028m.02-.03.016-.03-.016.03m.016-.03.015-.029-.015.028m.038-.063.016-.028-.016.028m.018-.033.016-.028-.016.028m.036-.06.016-.026-.016.026m4.917-4.553c.01-.008.021-.013.031-.02-.01.007-.02.012-.03.02m.043-.028c.01-.005.02-.013.031-.018l-.03.018m.043-.025.03-.018-.03.018m.126-.074c.013-.007.026-.012.036-.02l-.036.02",
    id: "empty-reaprofile_svg__e"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M.1 4.818",
    id: "empty-reaprofile_svg__f"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M.242 1.858a41.504 41.504 0 0 0 0 0",
    id: "empty-reaprofile_svg__i"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M.011.888a19.905 19.905 0 0 0 0 0",
    id: "empty-reaprofile_svg__l"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M.038.859",
    id: "empty-reaprofile_svg__o"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    id: "empty-reaprofile_svg__r",
    d: "M.87.863.546.534.107.092l.763.77"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M13.898 6.87 8.054 4.001l5.844 2.867m-7.6-3.73L.17.133l6.127 3.006",
    id: "empty-reaprofile_svg__u"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M1.835.83.235.09l1.6.74",
    id: "empty-reaprofile_svg__x"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M.343.205H.33.343",
    id: "empty-reaprofile_svg__A"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M34.837 20.794c-1.093 0-2.352-.357-3.683-1.127L4.724 4.355C3.007 3.363 1.437 1.842.192.127l35.59 20.57a4.46 4.46 0 0 1-.945.097",
    id: "empty-reaprofile_svg__D"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M.166 53.921V3.824C.166 1.86.822.537 1.888.034v50.332c0 1.829-.668 3.084-1.722 3.555",
    id: "empty-reaprofile_svg__G"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M172 151.538c0 4.78-3.947 7.104-9.118 4.156l-33.607-19.063c-5.174-2.948-9.275-9.714-9.275-14.494v-70.47c0-4.78 4.052-6.033 9.226-3.086l33.6 19.065c5.172 2.948 9.174 8.643 9.174 13.422v70.47",
    id: "empty-reaprofile_svg__K"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21 18.813c0 6.42-4.7 9.022-10.5 5.812S0 13.608 0 7.188C0 .767 4.7-1.835 10.5 1.375S21 12.392 21 18.813",
    id: "empty-reaprofile_svg__L"
  }), /*#__PURE__*/React__namespace.createElement("linearGradient", {
    x1: "-380.111%",
    y1: "-945.9%",
    x2: "359.06%",
    y2: "259.89%",
    id: "empty-reaprofile_svg__g"
  }, /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#FFFFFE",
    offset: "0%"
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#FFFFFE",
    offset: "100%"
  })), /*#__PURE__*/React__namespace.createElement("linearGradient", {
    x1: "-619.297%",
    y1: "-183.079%",
    x2: "209.602%",
    y2: "141.56%",
    id: "empty-reaprofile_svg__j"
  }, /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#FFFFFE",
    offset: "0%"
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#FFFFFE",
    offset: "100%"
  })), /*#__PURE__*/React__namespace.createElement("linearGradient", {
    x1: "-1495.323%",
    y1: "-2669.324%",
    x2: "639.94%",
    y2: "966.756%",
    id: "empty-reaprofile_svg__m"
  }, /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#FFFFFE",
    offset: "0%"
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#FFFFFE",
    offset: "100%"
  })), /*#__PURE__*/React__namespace.createElement("linearGradient", {
    x1: "-1193.048%",
    y1: "-543.018%",
    x2: "653.374%",
    y2: "226%",
    id: "empty-reaprofile_svg__p"
  }, /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#FFFFFE",
    offset: "0%"
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#FFFFFE",
    offset: "100%"
  })), /*#__PURE__*/React__namespace.createElement("linearGradient", {
    x1: "-6555.805%",
    y1: "-5559.951%",
    x2: "-3872.999%",
    y2: "1223.268%",
    id: "empty-reaprofile_svg__s"
  }, /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#FFFFFE",
    offset: "0%"
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#FFFFFE",
    offset: "100%"
  })), /*#__PURE__*/React__namespace.createElement("linearGradient", {
    x1: "-513.537%",
    y1: "-56.711%",
    x2: "-221.492%",
    y2: "117.607%",
    id: "empty-reaprofile_svg__v"
  }, /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#FFFFFE",
    offset: "0%"
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#FFFFFE",
    offset: "100%"
  })), /*#__PURE__*/React__namespace.createElement("linearGradient", {
    x1: "-4361.564%",
    y1: "-690.755%",
    x2: "-2079.502%",
    y2: "516.494%",
    id: "empty-reaprofile_svg__y"
  }, /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#FFFFFE",
    offset: "0%"
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#FFFFFE",
    offset: "100%"
  })), /*#__PURE__*/React__namespace.createElement("linearGradient", {
    x1: "-1804.51%",
    y1: "2174.69%",
    x2: "12800.69%",
    y2: "23073.79%",
    id: "empty-reaprofile_svg__B"
  }, /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#FFFFFE",
    offset: "0%"
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#FFFFFE",
    offset: "100%"
  })), /*#__PURE__*/React__namespace.createElement("linearGradient", {
    x1: "49.687%",
    y1: "-6.637%",
    x2: "27.106%",
    y2: "-72.782%",
    id: "empty-reaprofile_svg__E"
  }, /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#242E57",
    offset: "0%"
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#233158",
    offset: "100%"
  })), /*#__PURE__*/React__namespace.createElement("linearGradient", {
    x1: "50.888%",
    y1: "80.226%",
    x2: "50.52%",
    y2: "5.252%",
    id: "empty-reaprofile_svg__H"
  }, /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#436BA6",
    offset: "0%"
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#5481B5",
    offset: "100%"
  })), /*#__PURE__*/React__namespace.createElement("filter", {
    x: "-67.3%",
    y: "-22.7%",
    width: "234.6%",
    height: "163.6%",
    filterUnits: "objectBoundingBox",
    id: "empty-reaprofile_svg__J"
  }, /*#__PURE__*/React__namespace.createElement("feOffset", {
    dy: 10,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React__namespace.createElement("feGaussianBlur", {
    stdDeviation: 10,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React__namespace.createElement("feColorMatrix", {
    values: "0 0 0 0 0.247058824 0 0 0 0 0.243137255 0 0 0 0 0.294117647 0 0 0 0.2 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React__namespace.createElement("feOffset", {
    dy: 6,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React__namespace.createElement("feGaussianBlur", {
    stdDeviation: 3,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React__namespace.createElement("feColorMatrix", {
    values: "0 0 0 0 0.247058824 0 0 0 0 0.243137255 0 0 0 0 0.294117647 0 0 0 0.2 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React__namespace.createElement("feMerge", null, /*#__PURE__*/React__namespace.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React__namespace.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }))), /*#__PURE__*/React__namespace.createElement("circle", {
    id: "empty-reaprofile_svg__a",
    cx: 135.5,
    cy: 143.5,
    r: 135.5
  })), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    fill: "#B4CBEB",
    xlinkHref: "#empty-reaprofile_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M194.819 187.313c-3.288 2.414-9.353 2.067-12.896.036l-50.104-28.686c-3.542-2.028-3.857-7.223-.314-9.252l15.137-3.082c4.486-1.404 9.384-2.084 12.927-.054l44.456 23.66c3.543 2.03 1.667 6.358-.557 8.928-1.947 2.251-6.21 6.661-8.65 8.45",
    fill: "#3E597E"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M194.036 185.315c-3.308 2.412-9.411 2.064-12.976.036l-50.418-28.688c-3.565-2.028-3.5-5.354.064-7.382l14.851-4.952c4.514-1.403 9.443-2.084 13.008-.055l44.27 25.189c3.566 2.028 2.142 4.829-.095 7.402-1.96 2.251-6.249 6.659-8.704 8.45",
    fill: "#233359"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M105.074 254.997c-3.936 0-7.656-1.073-11.327-3.493-.482-.32-13.666-9.87-13.666-9.87s24.81-36.304 58.574-41.47c10.58-1.618 18.236-14.537 20.444-19.548-.488-.302-.98-.604-1.474-.912-14.535-9.064-25.396-18.131-24.262-20.258.164-.303.562-.449 1.167-.449 3.635 0 14.751 5.244 27.21 13.01 14.534 9.064 25.396 18.134 24.259 20.259-.162.301-.559.45-1.164.45-2.578 0-8.917-2.637-16.825-6.938 4.975 8.783 14.543 30.642-4.188 40.633-27.613 14.73-44.588 28.586-58.748 28.586",
    fill: "#3F3E4B",
    fillRule: "nonzero",
    style: {
      mixBlendMode: 'multiply'
    },
    opacity: 0.3,
    transform: "translate(3)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m165.793 237-22.018 11.884c-2.254 1.261-2.361 3.15-.323 4.286 1.984 1.111 5.413 1.088 7.28.044L173 241.2l-7.207-4.2",
    fill: "#233359"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(147 220)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-reaprofile_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-reaprofile_svg__b"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M13.208 39.856c-4.738 0-11.616-.65-13.04-1.4.134.008.27.01.405.01 1.285 0 2.555-.263 3.45-.776l21.634-11.982-.145-.42.039-.496 2.493-1.43.018-.01c4.168 1.676 9.058 2.515 13.946 2.515 6.22 0 12.436-1.36 17.171-4.075 3.585-2.056 5.812-4.602 6.684-7.266l.01-.031c1-2.877.243-8.244.243-8.244s-.35.928-.761 1.86c-.42-.847-.98-1.675-1.683-2.475-.482-1.974-1.786-3.895-3.91-5.58 5.193.672 9.869 1.931 13.017 3.736 9.474 5.434 9.216 13.857 0 19.713-6.684 4.249-14.614 5.364-21.099 5.364-7.166-.002-12.568-1.364-12.568-1.364L17.623 39.403c-.557.318-2.266.453-4.415.453m24.433-19.01c-.041-.015-.08-.033-.129-.036-1.03-.084-2.02-.156-2.99-.256-.754-.413-1.606-.646-2.47-.754-.01-.003-.021-.003-.031-.003-.036 0-.067.008-.101.013-1.241-.625-2.477-.997-3.925-1.38a.494.494 0 0 0-.612.359.59.59 0 0 0-.317.308c-1.35-.925-2.4-1.946-3.146-3.023a8.517 8.517 0 0 1-.477-2.012c.859.784 1.886 1.528 3.076 2.21 4.276 2.454 9.876 3.68 15.478 3.68 5.603 0 11.206-1.229 15.48-3.68 1.566-.9 2.846-1.9 3.84-2.967-.313 1.457-1.123 2.885-2.43 4.19-.069-.21-.268-.395-.51-.395a.532.532 0 0 0-.232.056c-3.397 1.639-6.542 2.826-10.318 3.208a.395.395 0 0 0-.292-.126c-.018 0-.036 0-.056.003a8.097 8.097 0 0 1-.914.046c-.286 0-.58-.01-.875-.02-.291-.008-.585-.018-.877-.018-.511 0-1.01.028-1.468.138-.33.077-.65.139-.97.195-1.433 0-2.868-.026-4.292-.026a.48.48 0 0 0-.442.29",
    fill: "#3F3E4B",
    fillRule: "nonzero",
    style: {
      mixBlendMode: 'multiply'
    },
    opacity: 0.3,
    mask: "url(#empty-reaprofile_svg__c)"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M205.449 238.269c-.091-.271-.403-.5-.748-.335-3.418 1.62-6.585 2.794-10.384 3.171a.4.4 0 0 0-.351-.121c-.566.066-1.182.045-1.8.025-.816-.023-1.636-.048-2.361.12a18.47 18.47 0 0 1-.977.192c-1.441 0-2.885-.025-4.319-.025a.483.483 0 0 0-.444.286c-.042-.015-.08-.033-.13-.036-1.036-.083-2.034-.154-3.01-.253-.759-.408-1.616-.639-2.486-.745-.05-.008-.088.005-.132.01-1.25-.619-2.494-.986-3.951-1.364a.495.495 0 0 0-.616.355.59.59 0 0 0-.32.304c-6.44-4.334-6.064-10.818 1.165-14.891 7.646-4.307 20.082-4.307 27.726 0 6.392 3.602 7.434 9.09 3.138 13.307m7.275-11.115s-.353.918-.766 1.838c-1.102-2.185-3.169-4.246-6.216-5.962-9.535-5.373-25.051-5.373-34.586 0-2.423 1.364-4.228 2.948-5.418 4.636-.25-1.343-.686-2.142-1.33-.89-.925 1.803-.641 4.905-.36 6.725.043.477.129.953.261 1.427l.003.015c.613 2.17 2.14 4.274 4.59 6.107l-3.187 1.794-.858-.481-20.978 11.403-1.683-2.21c-2.546 3.336-.385 5.84.597 6.403h.003c.111.078.233.157.363.23 1.927 1.085 5.257 1.063 7.07.044l21.774-11.845-.146-.416.04-.49 2.508-1.413.019-.01c9.534 3.766 22.807 3.254 31.318-1.542 3.608-2.033 5.85-4.55 6.727-7.183l.01-.03c1.006-2.845.245-8.15.245-8.15",
    fill: "#3E597E"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(167 214)"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    fillOpacity: 0.4,
    fill: "#F4F4F4",
    xlinkHref: "#empty-reaprofile_svg__e"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#233359",
    d: "M170.031 242 164 238.752l6.966-3.752 6.034 3.248-4.343 2.307v1.06l-2.626.385"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M202.394 219.277c-7.662-4.534-20.129-4.534-27.788 0-7.664 4.534-7.664 11.913 0 16.447 7.662 4.533 20.126 4.533 27.788 0 7.661-4.534 7.661-11.913 0-16.447Zm-31.227 18.48c-9.556-5.655-9.556-14.859 0-20.516 9.557-5.655 25.109-5.655 34.666 0 9.556 5.657 9.556 14.861 0 20.516-9.557 5.657-25.109 5.657-34.666 0Z",
    fill: "#233359"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#3E597E",
    d: "m156.352 136-2.352.764v.16l2.5 1.57v10.77l35.34 21.077.968 2.659 2.192-.762v-13.265L156.352 136"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#233359",
    d: "m193 173-39-22.189V138l39 22.19V173"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M255 185.358c0 3.603-6.29 6.939-9.45 5.139l-139.826-79.974c-3.161-1.802-5.724-6.183-5.724-9.785l.078-96.326c0-3.602 7.005-5.528 10.166-3.727l139.03 78.469c3.163 1.801 5.726 6.182 5.726 9.785v96.42",
    fill: "#233359"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M249 186.955c0 3.613-2.538 5.077-5.67 3.272l-137.663-79.432c-3.13-1.806-5.667-6.199-5.667-9.811V5.044c0-3.612 2.538-5.077 5.667-3.27l137.663 79.43c3.132 1.806 5.67 6.2 5.67 9.812v95.939",
    fill: "#233359"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M246 183.125c0 3.461-2.436 4.864-5.442 3.135L108.44 110.172c-3.003-1.73-5.439-5.938-5.439-9.398v-91.9c0-3.46 2.436-4.863 5.44-3.133l132.118 76.086c3.006 1.73 5.442 5.939 5.442 9.4v91.898",
    fill: "#E2EBF2"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m239.93 185.946-56.63-32.75c1.746-.376 2.879-1.827 2.879-4.042V92.46c0-3.845-3.358-9.092-7.46-11.464l-26.55-15.337c-1.369-.792-2.642-1.163-3.728-1.163a3.96 3.96 0 0 0-1.364.227v-1.21c0-3.513-3.22-8.308-6.966-10.474l-5.971-3.426c4.581-1.787 9.935-2.804 16.188-2.804 6.77 0 14.58 1.19 23.619 3.891.132.086.264.167.399.245 1.078.624 2.097.92 3 .92.088 0 .178-.002.264-.008l.029.009c6.637 2.205 12.462 3.897 17.57 5.15l44.722 25.862c3.334 1.93 6.04 6.691 6.04 10.636v88.782c0 2.82-1.384 4.458-3.39 4.458-.802 0-1.701-.26-2.65-.807ZM108.762 110.09a9.131 9.131 0 0 1-1.05-.716c-.272-5.164-.33-13.414 1.094-22.25v6.325c0 3.513 3.21 8.432 6.956 10.599l24.402 14.012c1.218.704 2.374 1.031 3.38 1.031.47 0 .908-.07 1.302-.209v6.343c0 2.234 1.102 4.987 2.828 7.368l-38.912-22.503Zm72.069-61.389 12.994 7.513-12.994-7.513ZM108.743 7.023a6.542 6.542 0 0 0-1.361-.605 4.446 4.446 0 0 0-1.28-.205h.01c.8 0 1.698.26 2.65.81l59.1 34.178-59.119-34.178Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M168.036 39c-.025-.014-.036.442-.036.726 0 4.54 3.135 10.016 7.001 12.287 3.866 2.27 6.999.5 6.999-4.041.002-.284-.009-.778-.033-.792L168.036 39",
    fill: "#233359"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M176 47.17c0 .741-.672 1.042-1.5.672-.828-.371-1.5-1.272-1.5-2.013 0-.74.672-1.04 1.5-.67s1.5 1.271 1.5 2.012",
    fill: "#121C31"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M43.011 50.834c-4.488 0-8.884-.958-12.807-3.359-.46-.283 9.716-43.38 9.716-43.38l41.2 13.264c16.381 6.912 6.472 9.86-4.936 20.26-4.305 3.928-19.194 13.215-33.173 13.215",
    fill: "#3F3E4B",
    fillRule: "nonzero",
    style: {
      mixBlendMode: 'multiply'
    },
    opacity: 0.3,
    transform: "translate(3 128)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E9F5F6",
    d: "M38.054 168 5 149.112 41.946 128 75 146.889 38.054 168"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#5787B9",
    d: "M64.766 148 52 140.706l1.237-.706L66 147.294l-1.234.706M60.766 150 48 142.705l1.237-.705L62 149.294l-1.234.706M36.743 163 24 156.627l1.254-.627L38 162.373l-1.257.627M56.828 152 33 137.704l1.172-.704L58 151.296l-1.172.704M54.828 154 31 139.703l1.172-.703L56 153.296l-1.172.704M49.828 155 26 140.703l1.172-.703L51 154.297l-1.172.703M46.828 157 23 142.703l1.172-.703L48 156.297l-1.172.703M42.828 160 19 145.703l1.172-.703L44 159.297l-1.172.703M39.828 162 16 147.704l1.172-.704L41 161.296l-1.172.704M44.168 140 36 135.643 42.83 132l8.17 4.357L44.168 140"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E9F5F6",
    d: "M38 177v-8.535L75 147v8.535L38 177"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#92C8E2",
    d: "M73.871 147 37 168.772l.129.228L74 147.228M73.871 148 37 169.772l.129.228L74 148.228M75.871 149 39 170.772l.129.228L76 149.228M75.871 150 39 171.772l.129.228L76 150.228"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#92C8E2",
    d: "M73.871 151 37 172.772l.129.228L74 151.228M75.871 151 39 172.772l.129.228L76 151.228M73.871 153 37 174.772l.129.228L74 153.228M73.871 154 37 175.772l.129.228L74 154.228"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E9F5F6",
    d: "M4 156.917V148l34 20.083V177L4 156.917"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#92C8E2",
    d: "M37 168.78 4.129 150l-.129.22L36.871 169M37 169.78 4.129 151l-.129.22L36.871 170M37 170.78 4.129 152l-.129.22L36.871 171"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#92C8E2",
    d: "M37 170.78 4.129 152l-.129.22L36.871 171M37 171.78 4.129 153l-.129.22L36.871 172M37 172.78 4.129 154l-.129.22L36.871 173M37 173.78 4.129 155l-.129.22L36.871 174M37 174.78 4.129 156l-.129.22L36.871 175"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#F5D550",
    d: "m5.282 156-.06-1.11L3 154.86 6.72 153 9 154.14 5.282 156"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E8812C",
    d: "m13.282 165-.064-1.11-2.218-.03 3.718-1.86L17 163.14 13.282 165"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#DE4A2A",
    d: "m12.28 159-.062-1.11-2.218-.03 3.718-1.86L16 157.14 12.28 159"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M147 115.27c0 3.465-3.146 4.85-6.865 2.713l-24.228-13.817c-3.72-2.137-6.907-6.987-6.907-10.451V42.638c0-3.464 3.122-4.727 6.842-2.59l24.241 13.817c3.72 2.137 6.917 6.865 6.917 10.33v51.075",
    fill: "#5787B9"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E9F5F6",
    d: "m143 95-29-15.53V76l29 15.529V95M143 102l-29-15.53V83l29 15.53V102M136 107l-22-13.1V91l22 13.1v2.9M136 86l-22-12.768V70l22 12.769V86M136 64.748c0 4.691-3.582 6.593-7.999 4.247-4.42-2.346-8.001-8.05-8.001-12.743 0-4.692 3.582-6.593 8.001-4.247 4.417 2.346 7.999 8.05 7.999 12.743"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M132 58.25c0 1.506-1.117 2.167-2.5 1.476-1.38-.69-2.5-2.47-2.5-3.977 0-1.505 1.12-2.166 2.5-1.475 1.383.69 2.5 2.471 2.5 3.976M133 71.86c0 3.887-11-3.097-11-6.985 0-4.75 2.462-5.916 5.5-3.988 3.038 1.93 5.5 6.221 5.5 10.972",
    fill: "#5787B9"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M130 61a11.321 11.321 0 0 1-2-1.055c.18-.22.18-.535 0-.945a11.31 11.31 0 0 1 2 1.056c-.18.22-.18.534 0 .944",
    fill: "#5787B9"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M127.332 55.649c.054.128.105-.047.204-.223.094-.172.236-.344.469-.233.47.224.536.572 1.035.846.525.288 1.177.314 1.514.499.805.442 1.18 2.613 1.268 2.454.461-.84-.12-2.212-.12-2.212l.273-.586-.544-.057.115-.46-.375.148s-.22-.653-.617-.882c-.396-.23-.512-.804-1.603-1.58-1.37-.969-2.55.07-1.619 2.286",
    fill: "#2B3B6E"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E9F5F6",
    d: "m125.499 69.566-.927.037.177-1.423-.749-1.667 1.036.554L125.5 66l.465 1.766L127 68.774l-.75.536.176 1.69-.927-1.434"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#5787B9",
    d: "m128.499 73.566-.925.036.175-1.423-.749-1.667 1.036.555L128.5 70l.465 1.766L130 72.773l-.75.537.178 1.69-.93-1.434M133.501 75.566l-.927.037.178-1.423-.752-1.667 1.036.554.465-1.067.463 1.766L135 74.774l-.75.536.176 1.69-.925-1.434"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(122 55)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-reaprofile_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-reaprofile_svg__f"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M.1 4.818",
    fill: "url(#empty-reaprofile_svg__g)",
    mask: "url(#empty-reaprofile_svg__h)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(130 51)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-reaprofile_svg__k",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-reaprofile_svg__i"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M.242 1.858a41.504 41.504 0 0 0 0 0",
    fill: "url(#empty-reaprofile_svg__j)",
    mask: "url(#empty-reaprofile_svg__k)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(129 53)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-reaprofile_svg__n",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-reaprofile_svg__l"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M.011.888a19.905 19.905 0 0 0 0 0",
    fill: "url(#empty-reaprofile_svg__m)",
    mask: "url(#empty-reaprofile_svg__n)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(127 54)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-reaprofile_svg__q",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-reaprofile_svg__o"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M.038.859",
    fill: "url(#empty-reaprofile_svg__p)",
    mask: "url(#empty-reaprofile_svg__q)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(196 56)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-reaprofile_svg__t",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-reaprofile_svg__r"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "url(#empty-reaprofile_svg__s)",
    mask: "url(#empty-reaprofile_svg__t)",
    d: "M.87.863.546.534.107.092l.763.77"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(168 41)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-reaprofile_svg__w",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-reaprofile_svg__u"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M13.898 6.87 8.054 4.001l5.844 2.867m-7.6-3.73L.17.133l6.127 3.006",
    fill: "url(#empty-reaprofile_svg__v)",
    mask: "url(#empty-reaprofile_svg__w)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(174 45)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-reaprofile_svg__z",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-reaprofile_svg__x"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M1.835.83.235.09l1.6.74",
    fill: "url(#empty-reaprofile_svg__y)",
    mask: "url(#empty-reaprofile_svg__z)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(107 7)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-reaprofile_svg__C",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-reaprofile_svg__A"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M.343.205H.33.343",
    fill: "url(#empty-reaprofile_svg__B)",
    mask: "url(#empty-reaprofile_svg__C)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(148 133)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-reaprofile_svg__F",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-reaprofile_svg__D"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M34.837 20.794c-1.093 0-2.352-.357-3.683-1.127L4.724 4.355C3.007 3.363 1.437 1.842.192.127l35.59 20.57a4.46 4.46 0 0 1-.945.097",
    fill: "url(#empty-reaprofile_svg__E)",
    mask: "url(#empty-reaprofile_svg__F)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(146 64)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-reaprofile_svg__I",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-reaprofile_svg__G"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M.166 53.921V3.824C.166 1.86.822.537 1.888.034v50.332c0 1.829-.668 3.084-1.722 3.555",
    fill: "url(#empty-reaprofile_svg__H)",
    mask: "url(#empty-reaprofile_svg__I)"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M238 166.27c0 3.464-3.169 4.85-6.888 2.713l-24.218-13.817c-3.717-2.137-6.894-6.988-6.894-10.452V93.638c0-3.464 3.1-4.727 6.819-2.59l24.251 13.817c3.72 2.137 6.93 6.865 6.93 10.328v51.077",
    fill: "#5787B9"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E9F5F6",
    d: "m219 132-14-7.848V121l14 7.848V132M233 147l-29-15.53V128l29 15.529V147M233 153l-29-15.53V134l29 15.53V153M227 157l-22-13.1V141l22 13.099V157M220 103.005c4.418 2.346 8 8.05 8 12.742 0 2.838-1.31 4.655-3.324 5.13-.763-3.506-2.794-6.476-5.176-7.99-2.42-1.536-4.475-1.109-5.21 1.53-1.417-2.284-2.29-4.847-2.29-7.164 0-4.693 3.58-6.594 8-4.248Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M221.995 111.672c-.058 1.967-1.12 2.89-2.498 1.969-1.38-.92-2.497-3.297-2.497-5.306 0-2.01 1.116-2.891 2.497-1.97 1.379.922 2.591 2.204 2.498 5.307",
    fill: "#5787B9"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M221 115a11.24 11.24 0 0 1-2-1.055c.18-.22.18-.535 0-.945.666.267 1.332.619 2 1.056-.18.22-.18.534 0 .944",
    fill: "#5787B9"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M217.137 108.57c.04.258 0-2.322 1.295-1.649.47.244.681.759 1.175 1.03.524.287.903.044 1.24.22.867.45.78 2.992.865 2.82.462-.9.296-2.342.008-2.956-.12-.253-.126-.931-.521-1.014-.38-.081-.593-.719-1.68-1.498-1.365-.976-3.007-.908-2.382 3.048",
    fill: "#2B3B6E"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E9F5F6",
    d: "m215.501 121.566-.927.036.178-1.423-.752-1.667 1.036.555.465-1.067.463 1.766 1.036 1.007-.75.537.178 1.69-.927-1.434M220.5 124.566l-.927.037.178-1.423-.751-1.667 1.038.554.462-1.067.464 1.765 1.036 1.009-.749.537.176 1.689-.927-1.434M223.499 127.566l-.925.036.175-1.423-.749-1.667 1.036.555.463-1.067.465 1.765 1.036 1.008-.75.537.176 1.69-.927-1.434"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(3)"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    fill: "#000",
    filter: "url(#empty-reaprofile_svg__J)",
    xlinkHref: "#empty-reaprofile_svg__K"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    fill: "#FBC125",
    xlinkHref: "#empty-reaprofile_svg__K"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF2C1",
    d: "m149 106-19-11.043V91l19 11.043V106M169 125l-39-21.362V99l39 21.362V125M169 135l-39-21.361V109l39 21.361V135M161 139l-31-17.586V117l31 17.585V139"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(139 66)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-reaprofile_svg__M",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-reaprofile_svg__L"
  })), /*#__PURE__*/React__namespace.createElement("use", {
    fill: "#FFF2C1",
    xlinkHref: "#empty-reaprofile_svg__L"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20 27.766c0 4.572-16-4.701-16-9.274 0-6.402 3.582-7.857 7.999-5.296C16.419 15.757 20 21.364 20 27.766",
    fill: "#F5D550",
    mask: "url(#empty-reaprofile_svg__M)"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M145.73 69.484c-.664 1.362-3.671 5.044.24 7.545 3.907 2.501 10.21 7.244 8.838 3.705-1.057-2.728-1.538-6.84-2.094-8.286-1.157-3.03-5.263-6.483-6.984-2.964",
    fill: "#E98965"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M147.61 71.476c.672.022 1.8-.062 2.864.595 1.269.783 2.076 2.394 2.384 2.822.11.515.16 1.104.136 1.779-.042 1.125-.476 1.908-1.149 2.201-.097.297-.045.673.155 1.127-.999-.4-2-.928-3-1.583a.87.87 0 0 0 .179-.37c-1.26-1.132-2.179-3.048-2.179-4.712 0-.792.208-1.408.561-1.809l.049-.05Z",
    fill: "#F5D550"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF2C1",
    d: "m145.501 94.28-1.546.043.296-1.707-1.251-2 1.727.665L145.5 90l.772 2.119 1.727 1.21-1.248.643.296 2.028-1.547-1.72M139.501 90.28l-1.546.043.296-1.707-1.251-2 1.727.665L139.5 86l.772 2.119 1.727 1.21-1.248.643.296 2.028-1.547-1.72M133.501 85.28l-1.546.043.296-1.707-1.251-2 1.727.665L133.5 81l.772 2.119 1.727 1.21-1.248.643.296 2.028-1.547-1.72M151.5 98.28l-1.543.043.293-1.707-1.25-2 1.728.664.772-1.28.774 2.119 1.726 1.21-1.25.644.296 2.027-1.546-1.72M157.501 101.28l-1.546.043.296-1.707-1.251-2 1.73.664.771-1.28.772 2.118 1.727 1.21-1.25.645.295 2.027-1.544-1.72"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M75.349 166c4.211 4.008 7.015 7.177 7.015 7.177 6.45 20.95 11.293 20.802 7.018 40.823l-.652-.16c-.724 5.942-1.432 13.713-1.575 24.155-.005.216-.301 1.364-1.566 1.63-1.328.277-3.043 2.541-3.043 2.365-.051-14.513-3.522-16.11-2.276-25.875l1.488-5.781.024-.024.052-.05c-1.289-5.536-2.981-9.115-5.027-16.708-.868-3.23-1.916-7.508-3.387-10.53C69.34 174.627 75.349 166 75.349 166Z",
    fill: "#E9F5F6"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M84.553 243.988s-3.468.436-2.32-4.03c.275-1.078 2.675-.8 2.675-.8L86.64 234s.02 1.016 2.315 2.552c.956.64 5.036.738 6.094.92 7.9 1.364-2.565 5.253-2.565 5.253l-7.932 1.263",
    fill: "#EDCFB5"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m84.59 243.988 8.047-1.278s7.524-2.371 4.748-4.71c-.348.518-1.779 2.903-5.183 3.383-3.702.52-2.58.586-6.314.52-1.545-.025-2.53-1.347-2.72-2.716-.447.116-.83.328-.932.725-1.164 4.517 2.355 4.076 2.355 4.076",
    fill: "#E98965"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M98.325 252s-3.454.111-1.942-4.34c.366-1.075 2.705-.561 2.705-.561l2.153-5.099s-.068 1.036 2.06 2.826c.887.746 4.896 1.234 5.925 1.522 7.662 2.153-2.979 5.121-2.979 5.121l-7.922.53",
    fill: "#EDCFB5"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m98.36 251 8.04-.533s7.619-1.69 5.083-4.324c-.39.49-2.002 2.776-5.4 2.936-3.689.177-2.593.35-6.266-.07-1.52-.174-2.377-1.607-2.443-3.009-.453.073-.851.252-.986.642-1.533 4.47 1.972 4.358 1.972 4.358",
    fill: "#E98965"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M106.986 209.537c-.043-2.582-9.615 4.982-9.615 4.982l.328 7.874c-2.05 9.469 1.18 11.35-.022 25.597-.013.173 1.844-1.894 3.154-2.047 1.248-.145 2.77-1.246 2.792-1.457 1.696-16.746 3.558-23.206 3.363-34.949",
    fill: "#E9F5F6"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M82.177 182c-2.134 1.345-4.754 2.228-7.177 3.109.49.792 1.069 1.56 1.54 2.374 1.237 2.127 2.448 4.228 3.828 6.28 1.279 1.901 2.516 3.735 3.054 5.945.474 1.932.544 3.922.578 5.896.078 4.67.589 10.01-1.128 14.495-.676 1.771-1.8 19.173-.353 18.898 1.377-.263 1.7-1.4 1.705-1.613.16-10.696.982-18.558 1.798-24.518l.196.044c3.842-16.215.999-19.1-4.041-30.91",
    fill: "#3F3E4B",
    fillRule: "nonzero",
    style: {
      mixBlendMode: 'multiply'
    },
    opacity: 0.3,
    transform: "translate(3)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M75.387 167.883c5.18-1.08 3.773-9.885 2.005-9.883-2.424.001-3.31 1.495-3.36 2.54-.058 1.219 1.09 1.935-.961 4.063-2.501 2.594-.16 3.795 2.316 3.28",
    fill: "#EDCFB5"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M75.01 166c7.432 11.297 25.35 10.839 25.35 10.839 5.778 18.992 6.158 19.314 6.64 37.165L97.801 218c-2.772-6.433-7.071-8.953-10.572-23.457-.786-3.258-6.89-5.828-8.405-8.85C74.622 177.297 75.01 166 75.01 166",
    fill: "#E9F5F6"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M72.339 125c.207 0 .442.001.7.005.23-.01.453-.005.67.013 3.338.095 9.487.62 14.375 3.334 5.308 2.946 9.024 5.427 10.913 7.304H99c5.533.057 13.327-.982 18.668-3.019 3.595-1.371 5.377-4.284 7.259-3.508 4.707 1.941 2.605 4.995 2.605 4.995-1.217 1.466-16.3 11.963-24.81 12.82.063.221.127.441.193.658.656 2.158-2.69 7.032-3.12 7.645l-.04.057c.596 3.683-2.134 8.091-1.967 12.016.232 5.539 2.305 10.42 2.305 10.42-15.948 5.677-25.267-9.593-24.733-10.787 2.175-4.857 4.407-6.811.867-16.08-1.382-3.619-3.24-9.175-3.822-13.846-4.577 1.42-9.555 3.529-13.086 5.875-.253.168-.492.343-.72.522 5.69 3.545 11.16 10.007 17.202 15.675.943.883-1.715 4.86-2.77 3.686-8.89-9.877-16.437-10.431-21.02-15.018-4.023-1.11-2.852-4.139-2.852-4.139.707-1.424 9.392-11.106 17.039-15.92 1.017-1.253 2.776-2.709 6.14-2.708Z",
    fill: "#233359"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M95.183 156.605c-.416 2.145-1.838 4.93-2.218 7.485-.516 3.494.702 8.634-2.744 10.99-3.252 2.22-8.193.772-11.288-1.067-2.881-1.714-5.132-4.126-6.82-6.903-.029.064-.06.128-.091.193-.54 1.16 8.872 15.985 24.978 10.473 0 0-2.094-4.739-2.328-10.117-.155-3.5 2.511-7.99 1.982-11.659l-1.471.605M55.338 143.851c.316-.285.653-.565 1.019-.828 3.328-2.386 7.94-4.539 12.29-6.06a2.211 2.211 0 0 1 .1-.963c-3.573-.044-15.074 5.564-14.74 8 .113.837.605.78 1.221 1.589 2.084 2.739 5.257 4.391 7.951 6.392 1.676 1.245 3.747 2.383 5.078 4.038 1.163 1.447 1.232 3.458 2.176 4.981.54-.65 1.621-.862 2.442-.424.174-.534.184-1.004-.084-1.245-6.128-5.53-11.698-11.796-17.453-15.48",
    fill: "#3F3E4B",
    fillRule: "nonzero",
    style: {
      mixBlendMode: 'multiply'
    },
    opacity: 0.3,
    transform: "translate(3)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M144.012 112.485c.68-.873 2.143-3.412 1.975-3.477-.421-.161-3.056 2.188-4.324 3.81-.472-.065-.928.022-1.282.457-.586.722-.54 1.816-.543 2.686 0 .073.018.134.04.194l-.022.082c-2.374 1.824.549 4.406 4.362 1.347 2.256-1.809 1.462-2.45 1.145-3.884-.32-1.434-1.35-1.215-1.35-1.215",
    fill: "#EDCFB5"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M141.84 119.212c-6.048 5.766-11.37 12.334-17.28 15.39-3.17 1.64-6.208-2.248-5.44-3.214 3.944-4.956 11.46-5.655 19.89-15.178.94-1.06 3.677 2.194 2.83 3.002",
    fill: "#233359"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M73.128 106.445c2.563-11.21 16.086-10.305 19.62-7.995 1.528.998 3.117 2.696 3.627 4.817.459 1.926 1.007 3.726.249 5.915-.67 1.928.569 2.68-.167 5.811-.451 1.92-.99 4.498-2.055 5.647-.641.69-1.543.441-2.533.422l.055.002c-.063 2.152-1.739 6.348.057 9.97.395.799-5.59 1.439-9.935.498-3.49-.754-5.595-2.99-4.92-3.493 2.833-2.104 1.98-6.31 1.468-8.055-.941-1.382-2.873-3.373-4.046-5.7-1.474-2.918-1.758-6.367-1.42-7.84Z",
    fill: "#EDCFB5"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M85.936 94.215c5.37-.844 12.873.62 14.01 7.577 1.139 6.958-16.048 3.128-9.891 23.513.1.338.186.66.277.986 1.36 3.253-5.383 2.742-8.01 2.58-4.812-.298-9.457-1.835-14.244-2.272-3.932-.358-5.046-1.303-5.077-2.231v-.002c-.018-.543.335-1.082.712-1.494a21.7 21.7 0 0 0 1.951-2.492c6.677-11.53 6.326-24.065 18.791-26.204.925-.158 1.77-.21 2.545-.154-.919.081-1.774.25-2.573.498.484-.12.986-.223 1.509-.305Z",
    fill: "#E98965"
  })));
});
var EmptyReaprofile = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.EmptyReaprofile = EmptyReaprofile;